import React from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import styled from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { HiOutlineChevronLeft, HiOutlineChevronRight, HiOutlineMail } from 'react-icons/hi';

// Styled Components
const BannerContainer = styled.div`
  position: relative;
  overflow: hidden;
  margin-top: 90px;   /* mobile */

  @media (min-width: 768px) {
    margin-top: 120px;  /* desktop */
  }


  .slick-prev, .slick-next {
    z-index: 1;
    width: 40px;
    height: 40px;
    background: ${({ theme }) => theme.colors.light};
    border-radius: 50%;
    display: flex !important;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
  }

  .slick-prev:hover, .slick-next:hover {
    background: ${({ theme }) => theme.colors.purple};
  }

  .slick-prev:before, .slick-next:before {
    display: none;
  }

  .slick-prev {
    left: 10px;
  }

  .slick-next {
    right: 10px;
  }

  .slick-dots {
    bottom: 10px;
  }

  .slick-dots li button:before {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.seconsdary};
  }

  .slick-dots li.slick-active button:before {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const CTAButtons = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px; /* ✅ space between buttons */
  width: 100%;
  padding: 0 12px;
`;


const EmailCTA = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  min-width: 120px;
  text-align: center;

  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.light};

  border: 1.5px solid ${({ theme }) => theme.colors.dark}; /* ✅ BORDER */
  padding: 6px 14px;
  border-radius: 24px;

  font-weight: 500;
  font-size: 0.85rem;
  text-decoration: none;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.dark};
    color: ${({ theme }) => theme.colors.light};
    border-color: ${({ theme }) => theme.colors.primary}; /* ✅ keeps brand */
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    min-width: 105px;
    padding: 5px 12px;
    font-size: 0.75rem;
  }

  @media (max-width: 480px) {
    min-width: 95px;
    padding: 4px 10px;
    font-size: 0.7rem;
  }
`;





// Arrow Components
const NextArrow = ({ onClick }) => (
  <div className="slick-arrow slick-next" onClick={onClick}>
    <HiOutlineChevronRight color="#2e9694" size={36} />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slick-arrow slick-prev" onClick={onClick}>
    <HiOutlineChevronLeft color="#2e9694" size={36} />
  </div>
);

// Component
const Banner = () => {
  const navigate = useNavigate();

  const images = [
    "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Purple_and_Blue_Modern_Educational_Institute_College_Billboard_3.png?v=1768722257",
  ];

  const settings = {
    dots: images.length > 1,
    infinite: images.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: images.length > 1,
    autoplaySpeed: 4000,
    nextArrow: images.length > 1 ? <NextArrow /> : null,
    prevArrow: images.length > 1 ? <PrevArrow /> : null,
  };

  return (
    <BannerContainer>
      {images.length > 1 ? (
        <Slider {...settings}>
          {images.map((src, index) => (
            <div key={index}>
              <BannerImage src={src} alt={`Banner ${index + 1}`} loading="lazy" />
            </div>
          ))}
        </Slider>
      ) : (
        <BannerImage src={images[0]} alt="Banner" loading="lazy" />
      )}

    <CTAButtons>
  <EmailCTA
    href="mailto:lkeduganesh@gmail.com"
    aria-label="Contact Us"
  >
    <span>Contact Us</span>
  </EmailCTA>

  <EmailCTA
    href="/form.pdf"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="View Form"
  >
    <span>View Form</span>
  </EmailCTA>
</CTAButtons>

    </BannerContainer>
  );
};

export default Banner;
